
<template lang="pug">
  div
    div(v-if="loading")
      | loading...
    div(v-else)
      .addresses-page
        .address(v-for="(address, index) in addresses")
          h2( v-if="address.default" )
            b Default Address
          p(aria-live="polite")
            b(v-if="addressUpdated") Your address has been updated.
          p
            | {{ address.first_name }} {{ address.last_name }}
            br(v-if="address.address1")
            | {{ address.address1 }}
            br(v-if="address.address2")
            | {{ address.address2 }}
            br
            | {{ address.city }} {{ address.province }} {{ address.zip }}
            br
            | {{ address.country }}
            br(v-if="address.phone")
            | {{ address.phone }}
          button.btn--primary(@click.prevent="editForm(index)") Edit Address
          button.btn--primary(v-if="!address.default" @click.prevent="makeDefault(index)") Make Default
          button.btn--primary(v-if="!address.default" @click.prevent="remove(index)") Delete
        button.btn--primary(@click.prevent='newAddress')
          span(aria-hidden="true") +
          | Add Address

      address-popup(v-if="showPopup" :create="createNewAddress" :address="address")
</template>

<script>
  import AddressPopup from 'scripts/components/account/AddressPopup.vue';

  export default {
    name: 'Addresses',

    components: {
      AddressPopup,
    },

    props: {
    },

    setup() {
    },

    mounted() {
      this.load();
    },

    data() {
      return {
        loading: true,
        showPopup: false,
        createNewAddress: true,
        address: {},
        addresses: [],
        addressUpdated: false
      }
    },

    validations () {
      return {
      }
    },

    methods: {
      load() {
        this.loading = true;
        fetch(
          this.$parent.url + 'addresses', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.$parent.getSession())
          }
        ).then(response => response.json()).then(data => {
          if (data.cdata)
            this.$parent.setSession(data);
          this.loading = false;
          this.addresses = data || [];
        }).catch(() => {
        });
      },

      editForm(index) {
        this.createNewAddress = false;
        this.address = Object.assign({}, this.addresses[index]);
        this.showPopup = true;
      },

      makeDefault(index) {
        fetch(
          this.$parent.url + 'default_address', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({ address_id: this.addresses[index].id }, this.$parent.getSession()))
          }
        ).then(response => response.json()).then((data) => {
          if (data.cdata)
            this.$parent.setSession(data);
          for (const k of this.addresses)
            k.default = false;
          this.addresses[index].default = true;
        }).catch(() => {
        });
      },

      remove(index) {
        fetch(
          this.$parent.url + 'delete_address', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({ address_id: this.addresses[index].id }, this.$parent.getSession()))
          }
        ).then(response => response.json()).then((data) => {
          if (data.cdata)
            this.$parent.setSession(data);
          this.addresses.splice(index, 1);
        }).catch(() => {
        });
      },

      newAddress() {
        this.createNewAddress = true;
        this.address = { first_name: '', last_name: '', country_code: 'US', company: '', address1: '', address2: '', city: '', zip: '', phone: ''};
        this.showPopup = true;
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
